var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeleg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0615 12C20.0615 16.4183 16.4798 20 12.0615 20C7.64325 20 4.06152 16.4183 4.06152 12C4.06152 7.58173 7.64325 4 12.0615 4C16.4798 4 20.0615 7.58173 20.0615 12ZM12.8282 9.5453C11.4538 10.1389 7.491 11.8249 7.491 11.8249C6.55185 12.2048 7.10157 12.561 7.10157 12.561C7.10157 12.561 7.90329 12.8459 8.5905 13.0596C9.27768 13.2733 9.6442 13.0359 9.6442 13.0359C9.6442 13.0359 11.2476 11.9436 12.874 10.7801C14.0193 9.97272 13.7444 10.6376 13.4695 10.9225C12.874 11.5399 11.889 12.5135 11.0644 13.2971C10.6979 13.6295 10.8811 13.9145 11.0415 14.0569C11.5078 14.466 12.6062 15.2099 13.1048 15.5476C13.243 15.6412 13.3351 15.7036 13.355 15.7191C13.4695 15.8141 14.1109 16.2415 14.5003 16.1465C14.8897 16.0515 14.9355 15.5054 14.9355 15.5054C14.9355 15.5054 15.2333 13.5583 15.5082 11.7774C15.5591 11.4277 15.61 11.0854 15.6575 10.7661C15.7809 9.93646 15.8811 9.26298 15.8976 9.0229C15.9663 8.21557 15.1417 8.54799 15.1417 8.54799C15.1417 8.54799 13.355 9.30786 12.8282 9.5453Z",
    fill: "#80899C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleg);
export default __webpack_public_path__ + "static/media/teleg.d217974ecced6941f5adac3e4b11c10a.svg";
export { ForwardRef as ReactComponent };